import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

import { ds } from '@/components/lib/design.system';

export const PlusIcon = props => {
    return (
        <Svg xmlns="http://www.w3.org/2000/svg" width={12} height={12} viewBox="0 0 12 12" fill="none" {...props}>
            <Path
                d="M6 2V10M2 6H10"
                stroke={props.color || ds.colorValue.icon.primary}
                strokeWidth={1.5}
                strokeLinecap="round"
            />
        </Svg>
    );
};
